import { render, staticRenderFns } from "./uuidRecord.vue?vue&type=template&id=cb185a5a&scoped=true&"
import script from "./uuidRecord.vue?vue&type=script&lang=js&"
export * from "./uuidRecord.vue?vue&type=script&lang=js&"
import style0 from "./uuidRecord.vue?vue&type=style&index=0&id=cb185a5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb185a5a",
  null
  
)

export default component.exports